import { Star, Quote } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export default function Testimonials() {
  const { t } = useLang();

  return (
    <section id="avis" data-testid="testimonials-section" className="bg-[#FAF8F5] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C87A57]">{t.testimonials.overline}</p>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-tight text-[#0E1B2A]">
            {t.testimonials.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-7 md:grid-cols-3">
          {t.testimonials.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="flex h-full flex-col rounded-2xl border border-[#0E1B2A]/8 bg-white p-8 shadow-[0_10px_30px_rgba(14,27,42,0.04)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_25px_50px_-15px_rgba(14,27,42,0.15)]"
              >
                <Quote size={28} className="text-[#D4AF37]/60" />
                <div className="mt-4 flex gap-1" aria-label="5/5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} className="fill-[#D4AF37] text-[#D4AF37]" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-[#334155]">
                  « {item.text} »
                </blockquote>
                <figcaption className="mt-6 border-t border-[#0E1B2A]/8 pt-5">
                  <p className="text-sm font-semibold text-[#0E1B2A]">{item.name}</p>
                  <p className="mt-0.5 text-xs uppercase tracking-widest text-[#C87A57]">{item.property}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
